export default "__VITE_ASSET__Bvgax9f8__"